import {
    useContext,
    type FC,
    useRef
} from "react";
import {
    Platform,
    View
} from "react-native";
import type ITraceHeadProps from "./type";
import type {
    TraceHeadElementType
} from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    CircleStop as CircleStopIcon
} from "lucide-react-native";
import {
    TraceContext
} from "../../context";
import Button from "../../../button";

const TraceHead: FC<ITraceHeadProps> = ({
    customLocalize: customLocalizeProp,
    customTheme: customThemeProp,
    onStopPress,
    children,
    style
}) => {
    const traceContext = useContext(TraceContext);

    const customLocalize = customLocalizeProp ?? traceContext?.customLocalize;

    const customTheme = customThemeProp ?? traceContext?.customTheme;

    const {
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const containerRef = useRef<View>(null);

    const handleStopPress = () => {
        if(Platform.OS === "web") {
            const element = containerRef.current as unknown as TraceHeadElementType | null;

            element?.querySelector?.("[aria-expanded]")?.focus?.();
        }

        onStopPress?.();
    };

    const renderStopIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => <CircleStopIcon
        color={customColor ?? colors.content.icon[color]}
        size={size}
    />;

    const renderStop = () => {
        if(!onStopPress) {
            return null;
        }

        return <Button
            customTheme={customTheme}
            onPress={handleStopPress}
            title={localize("stop")}
            icon={renderStopIcon}
            variant="ghost"
            type="neutral"
            size="small"
        />;
    };

    return <View
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        ref={containerRef}
    >
        {children}
        {renderStop()}
    </View>;
};
export default TraceHead;
